/* ============================================================
   OGFashionCheck — Balance Theme 3.5.1
   ============================================================ */
(function () {
  'use strict';

  /* ── 1. Custom Cursor ──────────────────────────────────────── */
  function initCursor() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if ('ontouchstart' in window) return;

    const dot  = document.createElement('div');
    dot.className = 'ogf-cursor';
    const ring = document.createElement('div');
    ring.className = 'ogf-cursor-ring';
    document.body.appendChild(dot);
    document.body.appendChild(ring);

    let mx = 0, my = 0, rx = 0, ry = 0;

    document.addEventListener('mousemove', e => {
      mx = e.clientX;
      my = e.clientY;
      dot.style.left = mx + 'px';
      dot.style.top  = my + 'px';
    });

    (function loop() {
      rx += (mx - rx) * 0.11;
      ry += (my - ry) * 0.11;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(loop);
    })();

    const hoverSel = 'a, button, [role="button"], .product-card, label, .swatch-label, .variant-input-wrapper label, input[type="submit"], .btn, .site-nav__link';
    document.querySelectorAll(hoverSel).forEach(el => {
      el.addEventListener('mouseenter', () => { dot.classList.add('hovered'); ring.classList.add('hovered'); });
      el.addEventListener('mouseleave', () => { dot.classList.remove('hovered'); ring.classList.remove('hovered'); });
    });

    document.addEventListener('mousedown', () => dot.classList.add('clicking'));
    document.addEventListener('mouseup',   () => dot.classList.remove('clicking'));
  }

  /* ── 2. Scroll Progress Bar ────────────────────────────────── */
  function initProgressBar() {
    const bar = document.createElement('div');
    bar.className = 'ogf-progress-bar';
    document.body.appendChild(bar);
    window.addEventListener('scroll', () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + Math.min(window.scrollY / total, 1) + ')';
    }, { passive: true });
  }

  /* ── 3. Scroll Reveal ──────────────────────────────────────── */
  function initScrollReveal() {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -36px 0px' });

    const selectors = [
      '.product-card',
      '.collection-grid__item',
      '.footer__blocks',
      '.footer__bottom',
      '.image-with-text__text-item',
      '.image-with-text__image-item',
      '.multicolumn-list__item',
      '.rich-text__text',
      '.blog-articles__post',
      '.featured-collection',
    ];

    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach((el, i) => {
        el.classList.add('ogf-scroll-reveal');
        const mod = i % 4;
        if (mod === 1) el.classList.add('d1');
        if (mod === 2) el.classList.add('d2');
        if (mod === 3) el.classList.add('d3');
        io.observe(el);
      });
    });

    document.querySelectorAll('.ogf-scroll-reveal').forEach(el => io.observe(el));
  }

  /* ── 4. Header Scroll ──────────────────────────────────────── */
  function initHeaderScroll() {
    const header = document.querySelector('.site-header, header[role="banner"]');
    if (!header) return;
    window.addEventListener('scroll', () => {
      header.classList.toggle('is-scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  /* ── 5. Cart Count Pulse ───────────────────────────────────── */
  function initCartPulse() {
    document.addEventListener('click', e => {
      if (!e.target.closest('.product-form__cart-submit, [data-add-to-cart], .quick-add__submit')) return;
      setTimeout(() => {
        const count = document.querySelector('.cart-count, .cart-count-bubble, [data-cart-count]');
        if (!count) return;
        count.classList.remove('ogf-pulse');
        void count.offsetWidth;
        count.classList.add('ogf-pulse');
        setTimeout(() => count.classList.remove('ogf-pulse'), 550);
      }, 450);
    });
  }

  /* ── 6. Product Image Zoom ─────────────────────────────────── */
  function initImageZoom() {
    document.querySelectorAll('.product__media-item img, .product-media-container img').forEach(img => {
      img.addEventListener('click', () => img.classList.toggle('ogf-zoomed'));
    });
  }

  /* ── 7. Announcement Bar Cycle ─────────────────────────────── */
  function initAnnouncementCycle() {
    const msgs = document.querySelectorAll('.announcement-bar__message');
    if (msgs.length < 2) return;
    let current = 0;
    msgs.forEach((m, i) => { if (i > 0) m.style.display = 'none'; });
    setInterval(() => {
      const next = (current + 1) % msgs.length;
      const curr = msgs[current];
      curr.style.opacity   = '0';
      curr.style.transform = 'translateY(-8px)';
      setTimeout(() => {
        curr.style.display   = 'none';
        curr.style.opacity   = '';
        curr.style.transform = '';
        msgs[next].style.display   = '';
        msgs[next].style.opacity   = '0';
        msgs[next].style.transform = 'translateY(8px)';
        requestAnimationFrame(() => {
          msgs[next].style.opacity   = '1';
          msgs[next].style.transform = 'translateY(0)';
        });
        current = next;
      }, 380);
    }, 4200);
  }

  /* ── 8. Page Transition ────────────────────────────────────── */
  function initPageTransition() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const overlay = document.createElement('div');
    overlay.className = 'ogf-page-overlay';
    document.body.appendChild(overlay);
    document.addEventListener('click', e => {
      const a = e.target.closest('a[href]');
      if (!a) return;
      const href = a.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') ||
          href.startsWith('tel:') || a.target === '_blank' ||
          e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      overlay.style.opacity = '1';
      setTimeout(() => { window.location.href = href; }, 270);
    });
    window.addEventListener('pageshow', () => {
      overlay.style.opacity = '0';
    });
  }

  /* ── 9. Add-to-Cart Feedback ───────────────────────────────── */
  function initCartFeedback() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('.product-form__cart-submit');
      if (!btn || btn.dataset.ogfActive) return;
      const orig = btn.innerHTML;
      btn.dataset.ogfActive = '1';
      btn.disabled = true;
      btn.innerHTML = '✓&nbsp; Hinzugefügt';
      setTimeout(() => {
        btn.innerHTML = orig;
        btn.disabled  = false;
        delete btn.dataset.ogfActive;
      }, 2200);
    });
  }

  /* ── 10. Collection Grid Stagger ───────────────────────────── */
  function initGridStagger() {
    document.querySelectorAll(
      '.collection-grid, .product-grid, ul[class*="grid"]'
    ).forEach(grid => {
      grid.querySelectorAll(':scope > li, :scope > .collection-grid__item').forEach((item, i) => {
        item.style.animationDelay = (i * 0.065) + 's';
        item.classList.add('ogf-reveal');
      });
    });
  }

  /* ── Boot ──────────────────────────────────────────────────── */
  function boot() {
    initCursor();
    initProgressBar();
    initHeaderScroll();
    initCartPulse();
    initImageZoom();
    initAnnouncementCycle();
    initPageTransition();
    initCartFeedback();
    initGridStagger();
    requestAnimationFrame(() => {
      initScrollReveal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();